import React from 'react';
import ReactECharts from 'echarts-for-react';
import {EChartsOption} from 'echarts';
import styles from './LineChartPanel.module.css';

interface LineChartPanelProps {
    time: string[];
    series: {
        name: string;
        data: number[];
    }[];
    style?: React.CSSProperties;
}

const LineChartPanel: React.FC<LineChartPanelProps> = ({
                                                           time,
                                                           series,
                                                           style // Destructure the style prop
                                                       }) => {
    console.log("Time data:", time);
    console.log("Series data:", series);

    const validSeries = Array.isArray(series) ? series.filter(s => s && s.name && Array.isArray(s.data)) : [];

    const option: EChartsOption = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        legend: {
            data: validSeries.map(s => s.name),
            textStyle: {color: '#fff'},
            top: '5%',
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: Array.isArray(time) ? time : [],
            axisLabel: {color: '#fff'}
        },
        yAxis: {
            type: 'value',
            axisLabel: {color: '#fff'}
        },
        series: validSeries.map(s => ({
            name: s.name,
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            data: Array.isArray(s.data) ? s.data : [],
        }))
    };

    console.log("ECharts Option:", option);
    console.log("Series Type:", typeof series);
    console.log("Is series an array?", Array.isArray(series));
    if (Array.isArray(series)) {
        series.forEach((s, i) => console.log(`Series[${i}]`, s));
    }


    return (
        <div className={styles.chartContainer}
             style={{...style, width: style?.width || '100%', height: style?.height || '100%'}}>
            <ReactECharts option={option} style={{width: '100%', height: '100%'}}/>
        </div>
    );
};

export default LineChartPanel;
